import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList
} from '@angular/core';
import {
  MultiSelectDropdownComponent
} from '../multi-select-dropdown/multi-select-dropdown.component';
import {
  SharedService
} from '../../shared.service';
import {
  Subscription
} from 'rxjs/Subscription';
import { Router } from '@angular/router';
import Utils from 'src/app/utils';

@Component({
  selector: 'app-tree-search',
  templateUrl: './tree-search.component.html',
  styleUrls: ['./tree-search.component.scss']
})
export class TreeSearchComponent {
  @Input() filterCriteriaList; // holds filter criteria list to be populated in dropdown
  @Input() treeData; // holds tree data
  @Output() searchEvent: EventEmitter<any>; // holds search event value
  @Output() loaderEvent: EventEmitter<any>; // holds search event value
  @ViewChildren('filterCriteria') filterCriteriaDropdown: QueryList<MultiSelectDropdownComponent>;

  Object = Object;
  treeNodes: any;
  searchText = ''; // holds text input in search box
  openPanel = false; // holds flag value to toggle filter criteria drop-down
  filterListObj = {}; // holds formatted filter object with values
  selectedFilterList = []; // holds selected values to filter tree
  filterResult = []; // holds filtered tree nodes
  isSearchApplied = false; // holds flag if any filter or search is applied on tree data
  dropdownSettings = {
    textField: 'label',
    showLabel: true,
    buttonType: 'button'
  };
  filterObj = [];
  worker: any;
  searchResultList = [];
  arrayToSearch = [];
  disableFilter = true;
  isLoading = false;
  searchTextEvent: Subscription; // holds subscription for search
  searchEnabled = false; // holds boolean to determine if search is enabled
  isFirstTime = false;
  @Input() intializeCondition = false;
  @Input() showFilter = true;
  @Input() location = '';
    // analytics Event Name
    analyticsName: any;

  constructor(private sharedService: SharedService, private router: Router) {
    this.searchEvent = new EventEmitter<any>();
    this.loaderEvent = new EventEmitter<any>();

    this.searchTextEvent = this.sharedService.searchTextEvent.subscribe((res: any) => {
      setTimeout(() => {
        if (!res.trigger && this.treeData && this.treeData !== 'undefined' && this.treeData.length) {
          this.isLoading = true;
          this.loaderEvent.emit({
            isLoading: this.isLoading,
            isFirstTime: true
          });
          if (typeof Worker !== 'undefined') {
            this.worker = new Worker(new URL('../../treeService.worker', import.meta.url), { type: 'module' });
          }
          if (this.worker) {
            this.worker.onmessage = ({
              data
            }) => {

              if (data) {
                this.treeData = data.treeData;
                this.treeNodes = data.treeNodes;
                this.arrayToSearch = data.arrayToSearch;
                this.filterObj = data.filterObj;
                this.filterResult = data.filterResult;
                this.searchText = data.searchText;
                setTimeout(() => {
                  this.isLoading = false;
                  this.loaderEvent.emit({
                    isLoading: this.isLoading,
                    isFirstTime: false
                  });
                }, 500);
                this.searchEvent.emit({
                  filterData: this.searchResultList,
                  isFilterApplied: this.isSearchApplied,
                  treeData: this.treeData
                });
              }
            };
            if (!res.trigger && this.treeData && this.treeData !== 'undefined' && this.treeData.length) {
              console.log('Constructor worker');
              this.worker.postMessage({
                data: this.treeData,
                location: 'tree-search',
                parameters: {
                  filterCriteriaList: this.filterCriteriaList,
                  search: false,
                  searchText: this.searchText,
                  isReset: true,
                  clearMarkNode: true,
                  filterResult: this.filterResult,
                  filterObj: this.filterObj,
                }
              });
            }
          }
        } else {
          this.searchEnabled = false;
        }
      }, 500);

    });

    this.setAnalyticsName();

  }


  getFilterData(treeData, isFirstTime = false) {
    if (treeData) {
      this.isFirstTime = isFirstTime;
      this.isLoading = true;
      this.loaderEvent.emit({
        isLoading: this.isLoading,
        isFirstTime: this.isFirstTime
      });
      if (typeof Worker !== 'undefined') {
        this.worker = new Worker(new URL('../../treeService.worker', import.meta.url), { type: 'module' });
      }
      if (this.worker) {
        if (this.filterCriteriaList && this.filterCriteriaList.length === 0) {
          if (localStorage.getItem('filterCriteriaList')) {
            this.filterCriteriaList = JSON.parse(localStorage.getItem('filterCriteriaList'));
          }
        }
        this.worker.onmessage = ({
          data
        }) => {
          if (data) {
            this.treeData = data.treeData;
            this.treeNodes = data.treeNodes;
            this.arrayToSearch = data.arrayToSearch;
            this.searchResultList = data.searchResultList;
            this.searchText = data.searchText;
            this.filterListObj = data.filterListObj;
            this.filterObj = data.filterObj;
            this.filterResult = data.filterResult;
            setTimeout(() => {
              this.isLoading = false;
              this.loaderEvent.emit({
                isLoading: this.isLoading,
                isFirstTime: this.isFirstTime
              });
              this.isFirstTime = false;
            }, 500);
          }
        };
        console.log('getFilterData worker');
        this.worker.postMessage({
          data: treeData,
          location: 'tree-search',
          parameters: {
            filterCriteriaList: this.filterCriteriaList,
            search: false,
            searchResultList: this.searchResultList,
            selectedFilterList: this.selectedFilterList,
            filterObj: this.filterObj,
            filterResult: this.filterResult,
            searchText: this.searchText,
            showFilter: this.showFilter
          }
        });
      }
    }
  }

  // FUNCTION to emit search-box text to parent component
  emitSearchText(isReset) {
    // on enter click for search send the data to google analytics
    Utils.googleAnalyticsEventCapture(
      'enter',
      this.analyticsName + Utils.analyticsEvtName.treeSearch,
      this.getOrgCode() + '-' + this.getTaxonomyName()
    );
    this.isSearchApplied = ((this.searchText && this.searchText.length) || this.selectedFilterList.length) ? true : false;
    this.isLoading = true;
    this.loaderEvent.emit({
      isLoading: this.isLoading,
      isFirstTime: false
    });
    if (typeof Worker !== 'undefined') {
      this.worker = new Worker(new URL('../../treeService.worker', import.meta.url), { type: 'module' });
    }
    if (this.worker) {
      this.worker.onmessage = ({
        data
      }) => {
        if (data) {
          this.treeData = data.treeData;
          this.treeNodes = data.treeNodes;
          this.searchResultList = data.searchResultList;
          this.searchText = data.searchText;
          this.filterObj = data.filterObj;
          this.filterResult = data.filterResult;
          this.searchText = data.searchText;
          if (this.searchResultList && this.searchResultList.length) {
            this.arrayToSearch = this.searchResultList;
          } else {
            this.arrayToSearch = data.arrayToSearch;
          }
          if (isReset) {
            this.resetFilter(true);
          } else {
            this.searchEvent.emit({
              filterData: this.searchResultList,
              isFilterApplied: this.isSearchApplied,
              treeData: this.treeData
            });
          }
          setTimeout(() => {
            this.isLoading = false;
            this.loaderEvent.emit({
              isLoading: this.isLoading,
              isFirstTime: false
            });
          }, 500);
        }
      };
      console.log('emitSearchText worker');
      this.worker.postMessage({
        data: this.treeData,
        location: 'tree-search',
        parameters: {
          filterCriteriaList: this.filterCriteriaList,
          search: true,
          searchText: this.searchText,
          isReset,
          selectedFilterList: this.selectedFilterList,
          filterResult: this.filterResult,
          filterObj: this.filterObj,
          clearMarkNode: isReset
        }
      });
    }

  }


  // FUNCTION to clear search box
  clearSearchKeyword(isReset: boolean = false) {
    this.searchText = '';
    this.emitSearchText(isReset);

  }


  // FUNCTION to toggle panel containing filter criteria drop-downs
  toggleFilterPanel() {
      if(!this.openPanel)
      {
          this.openPanel = true;
          setTimeout(() => {
              document.getElementById('btn-multiselect-node_type').focus();
          },10);
      }
      else
      {
          this.openPanel = false;
      }
  }

  // FUNCTION to receive individual filter drop-down values
  getSelectedFilters(ev) {
    this.disableFilter = false;
    // add selected options to filter list
    ev.selectedData.forEach(option => {
      if (!this.selectedFilterList.find((obj) => obj.label.trim() === option.label.trim())) {
        this.selectedFilterList.push(option);
      }
    });
    // remove unselected options from the filter list
    this.selectedFilterList = this.selectedFilterList.filter(obj => obj.is_selected === 1);
  }

  // FUNCTION to apply all the filters to tree data
  applyFilter(isReset: boolean = false) {
    // on apply filter of nodetype clisk for search send the data to google analytics
    Utils.googleAnalyticsEventCapture(
      'click',
      this.analyticsName + Utils.analyticsEvtName.nodeTypeTreeSearch,
      this.getOrgCode() + '-' + this.getTaxonomyName()
    );
    this.filterResult = [];
    this.isSearchApplied = ((this.selectedFilterList && this.selectedFilterList.length) || this.searchText.length) ? true : false;
    if (!isReset && !this.isSearchApplied) {
      this.resetSearchFilter();
      return;
    }
    if (this.selectedFilterList.length) {
      if (this.searchText && this.searchText.length) {
        this.arrayToSearch = this.searchResultList;
        this.callGetFilterResult(isReset, this.arrayToSearch);
      } else {
        if (this.treeData instanceof Array) {
          this.treeData.forEach(tree => {
            this.callGetFilterResult(isReset, tree.children);
          });
        } else if (this.treeData instanceof Object) {
          this.callGetFilterResult(isReset, this.treeData.children);
        }
      }
    } else {
      this.filterObj = [];
      if (this.searchResultList && this.searchResultList.length && !isReset) {
        this.filterResult = this.searchResultList;
      } else {
        this.filterResult = [];
        this.arrayToSearch = this.treeNodes;
      }
      if (this.filterResult && this.filterResult.length) {
        this.arrayToSearch = this.filterResult;
      }
      this.callGetFilterResult(isReset, this.arrayToSearch);
      if (!isReset) {
        this.searchEvent.emit({
          filterData: this.filterResult,
          isFilterApplied: this.isSearchApplied,
          treeData: this.treeData
        });
      }
      this.openPanel = false;
    }

  }

  callGetFilterResult(isReset, dataForGetFilterResult) {
    this.isLoading = true;
    this.loaderEvent.emit({
      isLoading: this.isLoading,
      isFirstTime: false
    });
    if (typeof Worker !== 'undefined') {
      this.worker = new Worker(new URL('../../treeService.worker', import.meta.url), { type: 'module' });
    }
    if (this.worker) {
      this.worker.onmessage = ({
        data
      }) => {
        if (data) {
          this.treeData = data.treeData;
          this.treeNodes = data.treeNodes;
          this.arrayToSearch = data.arrayToSearch;
          this.filterResult = data.filterResult;
          this.searchText = data.searchText;
          this.filterObj = data.filterObj;
          setTimeout(() => {
            this.isLoading = false;
            this.loaderEvent.emit({
              isLoading: this.isLoading,
              isFirstTime: false
            });
          }, 500);
        }
        if (this.filterResult && this.filterResult.length) {
          this.arrayToSearch = this.filterResult;
        }
        if (!isReset) {
          this.searchEvent.emit({
            filterData: this.filterResult,
            isFilterApplied: this.isSearchApplied,
            treeData: this.treeData
          });
        }

      };
      console.log('callGetFilterResult worker');
      this.worker.postMessage({
        data: this.treeData,
        location: 'tree-search',
        parameters: {
          filterCriteriaList: this.filterCriteriaList,
          search: false,
          searchText: this.searchText,
          isReset,
          selectedFilterList: this.selectedFilterList,
          getFilterResult: true,
          dataForGetFilterResult,
          searchResultList: this.searchResultList,
          filterResult: this.filterResult,
          filterObj: this.filterObj
        }
      });
    }
    this.openPanel = false;
  }


  onClickOutside() {
      if (this.openPanel) 
      {
          this.toggleFilterPanel();
      }
  }

  // FUNCTION to reset filter
  resetFilter(isReset) {
    const filters = this.filterCriteriaDropdown.toArray();
    for (const criteria of filters) {
      criteria.clearAllSelect();
      criteria.addSelection(true);
    }
    if (this.selectedFilterList.length) {
      this.selectedFilterList = [];
    }
    this.applyFilter(isReset);
    this.isLoading = true;
    this.loaderEvent.emit({
      isLoading: this.isLoading,
      isFirstTime: true
    });
    if (typeof Worker !== 'undefined') {
      this.worker = new Worker(new URL('../../treeService.worker', import.meta.url), { type: 'module' });
    }
    if (this.worker) {
      this.worker.onmessage = ({
        data
      }) => {
        if (data) {
          this.treeData = data.treeData;
          this.treeNodes = data.treeNodes;
          this.arrayToSearch = data.arrayToSearch;
          this.filterObj = data.filterObj;
          this.filterResult = data.filterResult;
          this.searchText = data.searchText;
          setTimeout(() => {
            this.isLoading = false;
            this.loaderEvent.emit({
              isLoading: this.isLoading,
              isFirstTime: false
            });
          }, 1000);
          this.searchEvent.emit({
            filterData: this.filterResult,
            isFilterApplied: this.isSearchApplied,
            treeData: this.treeData
          });
        }
      };
      console.log('resetFilter worker');
      this.worker.postMessage({
        data: this.treeData,
        location: 'tree-search',
        parameters: {
          filterCriteriaList: this.filterCriteriaList,
          search: false,
          searchText: this.searchText,
          searchResultList: this.searchResultList,
          isReset: true,
          clearMarkNode: true,
          selectedFilterList: this.selectedFilterList,
          filterResult: this.filterResult,
          filterObj: this.filterObj
        }
      });
    }
  }

  resetSearchFilter() {
    this.clearSearchKeyword(true);
  }

  // FUNCTION to check if search box is empty
  checkSearchText() {
    if (this.searchText.length === 0 && this.isSearchApplied) {
      this.cancelSearch();
    }
  }


  cancelSearch() {
    if (!this.selectedFilterList.length) {
      this.resetSearchFilter();
    } else {
      this.clearSearchKeyword();
      if (document.getElementById('searchTaxonomies')) {
        document.getElementById('searchTaxonomies').focus();
      }
    }
  }

  clearFilter() {
    if (!this.searchText.length) {
      this.resetSearchFilter();
    } else {
      this.resetFilter(false);
    }
  }

    // set anaytics name from which location it is coming
    setAnalyticsName(){
        let contextPage = 'frontfacing';
        switch (true){
          case this.router.url.indexOf('taxonomy/list') !== -1:
              contextPage = 'taxonomy';
              break;
          case this.router.url.indexOf('taxonomy/detail') !== -1:
              contextPage = 'taxonomy_detail';
              break;
          case this.router.url.indexOf('project/list') !== -1:
              contextPage = 'project';
              break;
          case this.router.url.indexOf('project/detail') !== -1:
              contextPage = 'project_detail';
              break;
          case this.router.url.indexOf('/app/pacingguide/authoring') !== -1:
              contextPage = 'pacingGuide';
              break;
          case this.router.url.indexOf('/app/pacingguide/detail') !== -1:
              contextPage = 'pacingGuide';
              break;
          default:
              contextPage = 'frontfacing';
        }
        this.analyticsName = Utils.analyticsEvtName[contextPage];
    }

    // get org code
    getOrgCode() {
        if (localStorage.getItem('orgDetails')) {
          return (Utils.prefix + JSON.parse(localStorage.getItem('orgDetails')).orgCode);
        }
    }

    // get taxonomyName
    getTaxonomyName(){
        let taxonomyName = '';
        if (this.treeData && this.treeData.children && this.treeData.children.length > 0){
            taxonomyName = Utils.extractContentFromHtml(this.treeData?.children[0].title);
            taxonomyName = Utils.decodeTag(taxonomyName);
        }
        return taxonomyName;
    }
}
